import $ from 'jquery';
import datepicker from 'air-datepicker';

class MaRSEvents {

  // 1. describe and create/initiate object
  constructor() {
    setTimeout(this.LoadActiveResults(), 750);
    this.resultsDiv = $(".allEvents__Results");
    this.showButton = $(".allEvents__link");
    this.filterSelect = $(".allEvents__filter-child li");
    this.searchField = $("#event-search");
    this.loadMoreButton = $(".allEvents__load a");
    this.dateSelect = $("#event-date");
    this.postsPerPage = 12;
    this.screenWidth = $(window).width();
    this.events();
    this.isSpinnerVisible = false;
    this.isOverlayOpen = false;
    this.previousValue;
    this.typingTimer;
    this.loadInfo;
    this.body = $('body');
  }

  // 2. events
  events() {
    this.loadMoreButton.on("click", this.getMoreResults.bind(this));
    this.searchField.on("keyup", this.typingLogic.bind(this));
    this.filterSelect.on("click", this.filterLogic.bind(this));

    // Date Filter
    /*
    function dateFilterLogic(attrType, date) {

      if ($(this)) {
        if (date) {
          clearTimeout(this.typingTimer);
          if (!this.isSpinnerVisible) {
            this.resultsDiv.html(`
          <div class="sk-double-bounce">
            <div class="sk-child sk-double-bounce1"></div>
            <div class="sk-child sk-double-bounce2"></div>
          </div>`);
            this.isSpinnerVisible = true;
          }
          this.searchField.val("");
          this.typingTimer = setTimeout(this.getFilterResults(attrType, date), 750);
        } else if (!target && !this.isOpened) {

          if (!this.isSpinnerVisible) {
            this.resultsDiv.html(`
          <div class="sk-double-bounce">
            <div class="sk-child sk-double-bounce1"></div>
            <div class="sk-child sk-double-bounce2"></div>
          </div>`);
            this.isSpinnerVisible = true;
          }
          this.searchField.val("");
          this.typingTimer = setTimeout(this.getFilterResults(attrType, date), 750);
          this.isSpinnerVisible = true;
        }
      }
    }*/


    this.dateSelect.datepicker({
      dateFormat: 'd-mm-yy',
      onSelect: function (formattedDate, date, inst) {
        //this.dateFilterLogic('date', formattedDate);
      }
    });
    $('#event-date').data('datepicker');
  }

  // 3. methods (function, action...)
  typingLogic() {
    if (this.searchField.val() != this.previousValue) {
      clearTimeout(this.typingTimer);
      $(".mtoggle li.active span").html($(".mtoggle li.active span").attr("data-hold"));
      if (this.searchField.val()) {
        if (!this.isSpinnerVisible) {
          this.resultsDiv.html(`
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>`);
          this.isSpinnerVisible = true;
        }
        this.typingTimer = setTimeout(this.getResults.bind(this), 750);
      } else {

        if (!this.isSpinnerVisible) {
          this.resultsDiv.html(`
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>`);
          this.isSpinnerVisible = true;
        }
        this.typingTimer = setTimeout(this.getResults.bind(this), 750);
        this.isSpinnerVisible = true;
      }
    }
    this.previousValue = this.searchField.val();
  }


  filterLogic(e) {
    if ($(this)) {
      let curTarget = e.currentTarget;
      let target, slug = e.target;
      target = slug.getAttribute('data-slug');
      let attrType = curTarget.parentElement.getAttribute('data-pane');

      if (target) {
        clearTimeout(this.typingTimer);
        if (!this.isSpinnerVisible) {
          this.resultsDiv.html(`
          <div class="sk-double-bounce">
            <div class="sk-child sk-double-bounce1"></div>
            <div class="sk-child sk-double-bounce2"></div>
          </div>`);
          this.isSpinnerVisible = true;
        }
        this.searchField.val("");
        this.typingTimer = setTimeout(this.getFilterResults(attrType, target), 750);
      } else if (!target && !this.isOpened) {

        if (!this.isSpinnerVisible) {
          this.resultsDiv.html(`
          <div class="sk-double-bounce">
            <div class="sk-child sk-double-bounce1"></div>
            <div class="sk-child sk-double-bounce2"></div>
          </div>`);
          this.isSpinnerVisible = true;
        }
        this.searchField.val("");
        this.typingTimer = setTimeout(this.getFilterResults(attrType, target), 750);
        this.isSpinnerVisible = true;
      }
    }
  }

  dateFilterLogic(attrType, date) {
    if ($(this)) {
      if (target) {
        clearTimeout(this.typingTimer);
        if (!this.isSpinnerVisible) {
          this.resultsDiv.html(`
          <div class="sk-double-bounce">
            <div class="sk-child sk-double-bounce1"></div>
            <div class="sk-child sk-double-bounce2"></div>
          </div>`);
          this.isSpinnerVisible = true;
        }
        this.searchField.val("");
        this.typingTimer = setTimeout(this.getFilterResults(attrType, date), 750);
      } else if (!target && !this.isOpened) {
        if (!this.isSpinnerVisible) {
          this.resultsDiv.html(`
          <div class="sk-double-bounce">
            <div class="sk-child sk-double-bounce1"></div>
            <div class="sk-child sk-double-bounce2"></div>
          </div>`);
          this.isSpinnerVisible = true;
        }
        this.searchField.val("");
        this.typingTimer = setTimeout(this.getFilterResults(attrType, date), 750);
        this.isSpinnerVisible = true;
      }
    }
  }

  dateFormatter(date) {
    date = date.replace('January', 'Jan')
      .replace('February', 'Feb')
      .replace('March', 'Mar')
      .replace('April', 'Apr')
      .replace('May', 'May')
      .replace('June', 'Jun')
      .replace('July', 'Jul')
      .replace('August', 'Aug')
      .replace('September', 'Sep')
      .replace('October', 'Oct')
      .replace('November', 'Nov')
      .replace('December', 'Dec')
      .replace('Monday', 'Mon')
      .replace('Tuesday', 'Tue')
      .replace('Wednesday', 'Wed')
      .replace('Thursday', 'Thu')
      .replace('Friday', 'Fri')
      .replace('Saturday', 'Sat')
      .replace('Sunday', 'Sun');

    return date;
  }

  getResults() {
    if ($(".allEvents__Results").length) {
      $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/events?term=' + this.searchField.val() + '&page=1', (results) => {
        let currentPage = results.current_page;
        this.resultsDiv.html(`
            ${results.eventInfo.length ? '<div class="row allEvents__row events__boxes">' : '<p>No Event information matches the search term.</p>'}
              ${results.eventInfo.map(item => `<div class="col-12 col-md-4 col-sm-4 allEvents__event">
                <div class="eventSection__event">
                  ${item.add_event_cta === true ? `
                  <a href="${item.event_cta_link}">
                    <div class="eventSection__event-cta">
                      ${item.event_cta_content}
                      <i class="event__arrow"><svg xmlns="http://www.w3.org/2000/svg" width="45" height="10" viewBox="0 0 45 10">
                      <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                          <path d="M1 5h42M40 1l4 4-4 4"/></g></svg></i>
                    </div>
                  </a>` :

            `<a href="${item.external_link ? item.external_link : item.permalink}" ${item.external_link ? `target="_blank"` : ``}>
                  <div class="eventSection__event-featuredImg" style="background:url(${item.event_image}) no-repeat;"></div>
                  <div class="eventSection__event-contentWrapper">
                      <p class="eventSection__event-sponsor">${item.sponsor}</p>
                      <p class="bold">${item.title}</p>
                      <ul>
                          <li class="marsCal__icon"><span>${item.end_date && item.end_date !== item.start_date ? this.dateFormatter(item.start_date) + ' - ' + this.dateFormatter(item.end_date) : this.dateFormatter(item.start_date)}</span></li>
                          ${item.start_time ? `<li class="marsClock__icon"><span>${item.start_time} ${item.end_time ? ` - ${item.end_time}` : ``}</span></li>` : ''}
                          <li class="marsPin__icon"><span>${item.location}</span></li>
                      </ul>
                  </div>
                </a>`}
            </div></div>`).join('')}
            ${results.eventInfo.length ? '</div>' : ''}
      `);
        this.isSpinnerVisible = false;
        this.searchField.val() ? this.loadMoreButton.attr("data-url", `term=${this.searchField.val()}&page=2`) : '';
        `${results.max_pages == currentPage ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
      }).fail(function (jqXHR, textStatus, error) {
      });
    }
  }


  getFilterResults(filter, sectorValue) {
    $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/events?' + filter + '=' + sectorValue + '&page=1', (results) => {
      let currentPage = results.current_page;
      this.resultsDiv.html(`
            ${results.eventInfo.length ? '<div class="row allEvents__row events__boxes">' : '<p>No Event information matches the search term.</p>'}
              ${results.eventInfo.map(item => `<div class="col-12 col-md-4 col-sm-4 allEvents__event">
                <div class="eventSection__event">
                  ${item.add_event_cta === true ? `
                  <a href="${item.event_cta_link}">
                    <div class="eventSection__event-cta">
                      ${item.event_cta_content}
                      <i class="event__arrow"><svg xmlns="http://www.w3.org/2000/svg" width="45" height="10" viewBox="0 0 45 10">
                      <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                          <path d="M1 5h42M40 1l4 4-4 4"/></g></svg></i>
                    </div>
                  </a>` :

          `<a href="${item.external_link ? item.external_link : item.permalink}" ${item.external_link ? `target="_blank"` : ``}>
                  <div class="eventSection__event-featuredImg" style="background:url(${item.event_image}) no-repeat;"></div>
                  <div class="eventSection__event-contentWrapper">
                      <p class="eventSection__event-sponsor">${item.sponsor}</p>
                      <p class="bold">${item.title}</p>
                      <ul>
                          <li class="marsCal__icon"><span>${item.end_date && item.end_date !== item.start_date ? this.dateFormatter(item.start_date) + ' - ' + this.dateFormatter(item.end_date) : this.dateFormatter(item.start_date)}</span></li>
                          ${item.start_time ? `<li class="marsClock__icon"><span>${item.start_time} ${item.end_time ? ` - ${item.end_time}` : ``}</span></li>` : ''}
                          <li class="marsPin__icon"><span>${item.location}</span></li>
                      </ul>
                  </div>
                </a>`}
            </div></div>`).join('')}
            ${results.eventInfo.length ? '</div>' : ''}
      `);
      this.isSpinnerVisible = false;
      sectorValue ? this.loadMoreButton.attr("data-url", `sector=${sectorValue}&page=2`) : this.loadMoreButton.attr("data-url", `term=${sectorValue}&page=2`);
      `${(results.max_pages == currentPage || results.max_pages < currentPage) ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
    }).fail(function (jqXHR, textStatus, error) {
    });
  }


  LoadActiveResults() {
    if ($(".allEvents__Results").length) {
      $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/events?term=&page=1', (results) => {
        let currentPage = results.current_page;
        this.resultsDiv.html(`
            ${results.eventInfo.length ? '<div class="row allEvents__row eventSection__boxes">' : '<p>No Event information matches the search term.</p>'}
              ${results.eventInfo.map(item => `<div class="col-12 col-md-4 col-sm-4 allEvents__event ${item.add_event_cta === true ? "event__cta-wrapper" : ""}">
                <div class="eventSection__event">
                  ${item.add_event_cta === true ? `
                  <a href="${item.event_cta_link}"}>
                    <div class="eventSection__event-cta">
                      ${item.event_cta_content}
                      <i class="event__arrow"><svg xmlns="http://www.w3.org/2000/svg" width="45" height="10" viewBox="0 0 45 10">
                      <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                          <path d="M1 5h42M40 1l4 4-4 4"/></g></svg></i>
                    </div>
                  </a>` :

            `<a href="${item.external_link ? item.external_link : item.permalink}" ${item.external_link ? `target="_blank"` : ``}>
                  <div class="eventSection__event-featuredImg" style="background:url(${item.event_image}) no-repeat;"></div>
                  <div class="eventSection__event-contentWrapper">
                      <p class="eventSection__event-sponsor">${item.sponsor}</p>
                      <p class="bold">${item.title}</p>
                      <ul>
                          <li class="marsCal__icon"><span>${item.end_date && item.end_date !== item.start_date ? this.dateFormatter(item.start_date) + ' - ' + this.dateFormatter(item.end_date) : this.dateFormatter(item.start_date)}</span></li>
                          ${item.start_time ? `<li class="marsClock__icon"><span>${item.start_time} ${item.end_time ? ` - ${item.end_time}` : ``}</span></li>` : ''}
                          <li class="marsPin__icon"><span>${item.location}</span></li>
                      </ul>
                  </div>
                </a>`}
                  
            </div></div>`).join('')}
            ${results.eventInfo.length ? '</div>' : ''}
      `);
        this.isSpinnerVisible = false;
        this.loadMoreButton.attr("data-url", `term=${this.searchField.val()}&page=${parseInt(currentPage) + 1}`);
        `${(results.max_pages == currentPage || results.max_pages < currentPage) ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
      }).fail(function (jqXHR, textStatus, error) {
      });
    }
  }


  getMoreResults(e) {
    e.preventDefault();
    this.loadInfo = this.loadMoreButton.attr("data-url");
    if (!this.isSpinnerVisible) {
      this.resultsDiv.append(`
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>`);
      this.isSpinnerVisible = true;
    }

    $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/events?' + this.loadInfo, (results) => {
      let currentPage = results.current_page;
      this.resultsDiv.append(`
            ${results.eventInfo.length ? '<div class="row allEvents__row events__boxes">' : '<p>No Event information matches the search term.</p>'}
              ${results.eventInfo.map(item => `<div class="col-12 col-md-4 col-sm-4 allEvents__event">
                <div class="eventSection__event">
                  ${item.add_event_cta === true ? `
                  <a href="${item.event_cta_link}">
                    <div class="eventSection__event-cta">
                      ${item.event_cta_content}
                      <i class="event__arrow"><svg xmlns="http://www.w3.org/2000/svg" width="45" height="10" viewBox="0 0 45 10">
                      <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                          <path d="M1 5h42M40 1l4 4-4 4"/></g></svg></i>
                    </div>
                  </a>` :

          `<a href="${item.external_link ? item.external_link : item.permalink}" ${item.external_link ? `target="_blank"` : ``}>
                  <div class="eventSection__event-featuredImg" style="background:url(${item.event_image}) no-repeat;"></div>
                  <div class="eventSection__event-contentWrapper">
                      <p class="eventSection__event-sponsor">${item.sponsor}</p>
                      <p class="bold">${item.title}</p>
                      <ul>
                          <li class="marsCal__icon"><span>${item.end_date && item.end_date !== item.start_date ? this.dateFormatter(item.start_date) + ' - ' + this.dateFormatter(item.end_date) : this.dateFormatter(item.start_date)}</span></li>
                          ${item.start_time ? `<li class="marsClock__icon"><span>${item.start_time} ${item.end_time ? ` - ${item.end_time}` : ``}</span></li>` : ''}
                          <li class="marsPin__icon"><span>${item.location}</span></li>
                      </ul>
                  </div>
                </a>`}
            </div></div>`).join('')}
            ${results.eventInfo.length ? '</div>' : ''}
      `);

      setTimeout(function () {
        let elmnt = document.querySelectorAll(".allEvents__Results .allEvents__row");
        elmnt = elmnt[elmnt.length - 1];
        let offset = $(elmnt).offset();
        $('html, body').animate({
          scrollTop: offset.top - 70,
          scrollLeft: offset.left
        });
      }, 500);

      $('.sk-double-bounce').remove();
      this.isSpinnerVisible = false;
      this.loadMoreButton.attr("data-url", `term=${this.searchField.val()}&page=${parseInt(currentPage) + 1}`);
      `${results.max_pages == currentPage ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
    }).fail(function (jqXHR, textStatus, error) {
    });
  }
}

export default MaRSEvents;